import { Card, Table } from "react-bootstrap";
import useCallApi from "../../../hooks/useCallApi";
import moment from "moment";
import { colors } from '../../../theme/variables'
import Loading from '../../../templates/UI/Loading/Loading'
import { DropdownItem } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import serverColor from "../../../helpers/serverColor";
import { useEffect, useState } from "react";
import callAPI from "../../../helpers/callAPI";

const Clicks = () => {
    const [init, setInit] = useState(true)

    const [data, setData] = useState()
    const [dataLoaded, setDataLoaded] = useState(false)

    const fetchData = async () => {
        setDataLoaded(false)
        let result = await callAPI(`mbStatus/monitoring/clicks`, 'GET')
        if (result.success) {
            setData(result)
        }
        setDataLoaded(true)
    }

    useEffect(() => {
        if (init) {
            fetchData()
            setInit(false)
        }
        const interval = setInterval(() => {
            fetchData()
        }, 60000)
        return () => clearInterval(interval)
    }, [])
    return (
        <Card className="mb-3">
            <Card.Header>Clicks</Card.Header>
            <Card.Body>
                {dataLoaded && data ? (
                <Table className="m-0">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Started</th>
                            <th>Ended</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><FontAwesomeIcon className={serverColor(data.details.clickStats[0].click_stats_period < 600 ? 'A':'C')} icon="circle" />{data.details.clickStats[0].click_stats_period < 600 ? 'OK':'Problem'}</td>
                            <td>{moment(data.details.clickStats[0].last_start).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>{moment(data.details.clickStats[0].last_end).format('YYYY-MM-DD HH:mm:ss')}</td>
                            <td>{data.details.clickStats[0].click_diff} secs</td>
                        </tr>
                    </tbody>
                </Table>
                ) : (
                    <Loading />
                )}
            </Card.Body>
        </Card>
    )
}

export { Clicks }